import { type FC, type PropsWithChildren } from "react";

import { LocalizationProvider as LocalizationClientProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment-timezone";
// Vite бандлит только дефолтную локаль en, поэтому определение `ru` нужно
// импортировать явно. Без него updateLocale ниже собрал бы «русскую» локаль
// поверх английской базы: месяцы взялись бы из MONTHS_GENITIVE, а дни недели,
// форматы и относительное время остались бы английскими.
import "moment/locale/ru";
import { MONTHS_GENITIVE } from "@/shared/utils/formatDate";

/**
 * Админка целиком русская, локаль moment здесь одна и не переключается
 * (в отличие от партнёрского кабинета, см. partner/app/providers/
 * LocalizationProvider.tsx). Родительный падеж месяцев нужен пикерам:
 * «12 марта», а не «12 март».
 *
 * updateLocale правит определение локали, а не подменяет активную; активную
 * ставим следующей строкой явно, чтобы это не зависело от побочных эффектов
 * moment.
 */
moment.updateLocale("ru", {
  months: MONTHS_GENITIVE,
});
moment.locale("ru");

export const LocalizationProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <LocalizationClientProvider
      dateAdapter={AdapterMoment}
      dateLibInstance={moment}
      adapterLocale="ru"
    >
      {children}
    </LocalizationClientProvider>
  );
};
